<template>
  <div class="loading-container">
    <div v-if="logo" v-dompurify-html:svg="logo" class="pulse"></div>
    <div v-else class="pulse"></div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

import { ConciergeIdentityData } from '~types/concierge-event'
import { IdentityData } from '~concierge/types/IdentityTypes'
import { useIdentityStore } from '~conciergeUiCommons/store/identityStore'

export default defineComponent({
  setup() {
    const identityStore = useIdentityStore()
    let logo = ''
    if (identityStore.service === 'conciergeEvent' || identityStore.service === 'conciergeEmbed') {
      logo = (identityStore.identity as ConciergeIdentityData)?.logo || ''
    } else {
      logo = (identityStore.identity as IdentityData)?.logoUrl || ''
    }
    return {
      logo
    }
  }
})
</script>
<style lang="scss">
.loading-container {
  width: 100%;
  padding: 0.5em;
  display: flex;
  place-content: center;
  place-items: center;
  height: 9em;
}

.pulse {
  text-align: center;
}

.pulse svg {
  width: clamp(50px, 50%, 50vw);
  fill: var(--loading-color, var(--dealer-primary-color));
  animation: pulse 1.2s infinite;
  transform: perspective(164px) translateZ(0px);
}

@keyframes pulse {
  to {
    transform: perspective(164px) translateZ(88px);
    opacity: 0;
  }
}
</style>
